import React, { useState } from "react";
import PriceDetails from "./PriceDetails";
import B2C2BPriceDetails from "../../pages/gd/b2c2b/B2C2BPriceDetails";

const PriceTable = ({isB2C2B = false, priceCurrency = "MYR", prices, paxCount, roomTypes}: {isB2C2B?:boolean, priceCurrency: string, prices: any[], paxCount?: number, roomTypes?: Record<string, string>}) => {
  const parsePricingTiers = () => {
    const pricingTiers = prices.map((price) => {
      const displayPrice = price.display_price;
      const match = displayPrice.match(/(\d+)(?:st|nd|rd|th)\s*-\s*(\d+)(?:st|nd|rd|th)/i);
      
      let start = 1, end = price.seats;
      if (match) {
        start = parseInt(match[1]);
        end = parseInt(match[2]);
      }

      return {
        ...price,
        start,
        end,
      };
    });

    return pricingTiers;
  };

  return isB2C2B ? (
    <B2C2BPriceDetails paxCount={1} priceCurrency={priceCurrency} prices={parsePricingTiers()} roomTypes={roomTypes}/>
  ) : (
    <PriceDetails priceCurrency={priceCurrency} prices={prices} roomTypes={roomTypes}/>
  )
}

export default PriceTable;